import DictionaryForm from '@/modules/Dictionary/__form';
import {
  setItemCode,
  setItemName,
  setItemNameLat,
} from '@/modules/Dictionary/__form/item';
import FNumber from '@/plugins/form/FNumber';

export default class DictionaryTransportForm extends DictionaryForm {
  static permission = {
    add: [115],
    edit: [348],
    view: [115],
    remove: [349],
  };

  dictionary = 'transport';

  constructor(props = {}) {
    super(props);
    setItemName.bind(this)();
    setItemNameLat.bind(this)();
    setItemCode.bind(this)();
    this.setItemPlaces();
  }

  setItemPlaces() {
    this.places = new FNumber({
      name: 'Places',
      label: 'Основных мест',
    });
    this.setItem('places', this.places);
  }
}
